import React, { useState } from 'react';
import {Grid,TextField,Typography,FormControlLabel,FormControl,FormLabel,RadioGroup,Radio} from '@mui/material';
import { FaSave } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import CustomDialog from '../../../components/CustomDialog';
import SaveLoading from '../../../components/SaveLoading';

const PurchaseDialog = ({ open, setOpen, handleSave, saveLoading, isMobile }) => {
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [amount, setAmount] = useState(0);
    const [remark, setRemark] = useState("");

    const handleClear = () => {
        setAmount(0);
        setRemark("");
    }

    const handleRadioChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleInputChange = (value, type) => {
        if (type === "amount") {
            const numericValue = value === "" ? 0 : parseInt(value);
            if (isNaN(numericValue)) {
                return;
            }

            setAmount(numericValue);
        }
        else {
            setRemark(value);
        }
    }

    const handleCancel = () => {
        handleClear();
        setOpen(false);
    }

    return (
        <CustomDialog open={open} isMobile={isMobile}>
              { saveLoading &&
            <SaveLoading loading={saveLoading}/> 
            }
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Typography className='dark:text-customWhite'>Amount</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField size="small" label="Amount" value={amount} onChange={(e) => handleInputChange(e.target.value, 'amount')} />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography className='dark:text-customWhite'>Remark</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField size="small" label="Remark" value={remark} onChange={(e) => handleInputChange(e.target.value, 'remark')} />
                    </Grid>
                </Grid>
                <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label" className='dark:text-customWhite' style={{fontSize:'0.8rem'}}>Type</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                    >
                        <FormControlLabel value="home" control={<Radio size="small" checked={selectedValue === 'home'} onChange={handleRadioChange} />} label="Home" className='dark:text-customWhite'/>
                        <FormControlLabel value="away" control={<Radio size="small" checked={selectedValue === 'away'} onChange={handleRadioChange} />} label="Away" className='dark:text-customWhite'/>
                        <FormControlLabel value="over" control={<Radio size="small" checked={selectedValue === 'over'} onChange={handleRadioChange} />} label="Over" className='dark:text-customWhite'/>
                        <FormControlLabel value="under" control={<Radio size="small" checked={selectedValue === 'under'} onChange={handleRadioChange} />} label="Under" size="small"className='dark:text-customWhite'/>
                    </RadioGroup>
                </FormControl>
                <div className='flex justify-center items-center gap-4 mt-2 text-[0.875rem]'>
                    <div className='flex items-center gap-2'>
                        <button
                            onClick={() => handleSave(amount, remark, selectedValue, handleClear)}
                            className='flex items-center px-3 py-1 border rounded bg-background text-customBackColor dark:text-customLightYellow dark:border-none'
                        >
                            <FaSave className='mr-1' />Save
                        </button>
                    </div>
                    <div className='flex items-center gap-2'>
                        <button
                            className='flex items-center px-3 py-1 border rounded bg-customTitleColor dark:border-none'
                            onClick={() => handleCancel()}
                        ><ImCross className='mr-1' />Cancel
                        </button>
                    </div>
                </div>
        </CustomDialog>
    )
}

export default PurchaseDialog